/**
 * @file: TaskStatusUpdateBody.tsx
 *
 * `OrgTaskStatusUpdate` — the whole task changed status (finished /
 * cancelled / rolled back). Title color carries the status accent;
 * remark gets emphasised red on rollback.
 */

import { TaskStatusUpdateType } from '@euler/model/enum/TaskStatusUpdateType';
import { OrgTaskStatusUpdateFeedPayload } from '@euler/model/feed';
import { FC } from 'react';
import { View } from 'react-native';
import { BodyText, TitleText } from './common/primitives';

export const TaskStatusUpdateBody: FC<{
  p: OrgTaskStatusUpdateFeedPayload;
}> = ({ p }) => {
  const isRollback = p.status === TaskStatusUpdateType.Rollback;
  const isCancelled = p.status === TaskStatusUpdateType.Cancelled;
  const accent = isRollback ? '#ff3b30' : isCancelled ? '#8e8e93' : '#34c759';
  const label = isRollback ? '返单' : isCancelled ? '工单已取消' : '工单已完成';
  // Rollback rows already carry the same "返单" text on the descriptor
  // category chip, so the bold title duplicates it. Skip the title in
  // that case and lean on the chip; for finished / cancelled the title
  // ("工单已完成" / "工单已取消") still carries information over the
  // generic "工单状态" chip, so keep it.
  return (
    <View>
      {isRollback ? null : <TitleText color={accent}>{label}</TitleText>}
      {p.remark ? (
        <BodyText
          color={isRollback ? '#b91c1c' : undefined}
          mt={isRollback ? 0 : 6}
        >
          {isRollback ? `原因: ${p.remark}` : p.remark}
        </BodyText>
      ) : null}
    </View>
  );
};
